export default __webpack_public_path__ + "static/media/kiiper_Close.19d4285a.svg";